
import React, { useState, useEffect, useContext, createContext, Component } from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import axios from 'axios';

import { matchPath, useLocation } from "react-router-dom";

import { Route, Redirect } from 'react-router-dom';
import { Link, animateScroll as scroll } from "react-scroll";
import { Grid, Cell,Menu,MenuItem } from "react-foundation";

import {api_path} from '../../server.js'; 
import {banner_path} from '../../server.js'; 

import CurrencyFormat from 'react-currency-format';
import Header from '../../components/Header';
import CampoAuxiliares from './components/camposauxiliares';
import Fertilizantes from './components/fertilizantes';


function AnaliseSolo() {
    const [culturas, setCulturas] = useState([]);
    const [CulturaCombo, setCulturaCombo] = useState('');
    const [faseExportada, setFaseExportada] = useState('');
    const [cultura, setCultura] = useState();
    const [cultura_id, setCultura_id] = useState();
    const [analise, setAnalise] = useState();
    const [prop_nomepropriedade, setprop_nomepropriedade] = useState('');
    const [prop_nome, setprop_nome] = useState('');
    const [prop_nomeDiplay, setprop_nomeDiplay] = useState('');
    const [prop_fone, setprop_fone] = useState('');
    const [prop_email, setprop_email] = useState('');
    const [prop_lote, setprop_lote] = useState('');
    const [prop_gleba, setprop_gleba] = useState('');
    const [prop_matricula, setprop_matricula] = useState('');
    const [prop_hectares, setprop_hectares] = useState('');
    const [prop_alqueires, setprop_alqueires] = useState('');
    const [prop_cidade, setprop_cidade] = useState('');
    const [prop_uf, setprop_uf] = useState('');
    const [fase_gatilho, setFase_gatilho] = useState('');
    const [ano_aplicacao, setAno_aplicacao] = useState('');
    const [produtividade, setProdutividade] = useState('');
    //const [produtividade, setProdutividade] = useState('');
    const [identificacao_amostra, setIdentificacao_amostra] = useState('');
    const [talhao, setTalhao] = useState('');
    const [profundidade_cm, setProfundidade_cm] = useState('');
    const [ph_cacl2, setPh_cacl2] = useState('');
    const [ph_H2O, setPh_H2O] = useState('');
    const [aluminio, setAluminio] = useState('');
    const [hidrogenio, setHidrogenio] = useState('');
    const [fosforo, setFosforo] = useState('');
    const [carbono_organico, setCarbono_organico] = useState('');
    const [calcio, setCalcio] = useState('');
    const [magnesio, setMagnesio] = useState('');
    const [potassio, setPotassio] = useState('');
    const [sodio, setSodio] = useState('');
    const [enxofre, setEnxofre] = useState('');
    const [cobre, setCobre] = useState('');
    const [ferro, setFerro] = useState('');
    const [zinco, setZinco] = useState('');
    const [manganes, setManganes] = useState('');
    const [boro, setBoro] = useState('');
    const [argila, setArgila] = useState('');
    const [silte, setSilte] = useState('');
    const [areia, setAreia] = useState('');
    const [prnt_calcario, setPrnt_calcario] = useState('');
    const [analiseSucesso, setAnaliseSucesso] = useState(false);
    const [token, setToken] = useState();

    let query = new URLSearchParams(useLocation().search);
    //var laudo_id = query.get("id");
    const [laudo_id, setLaudo_id] = useState(query.get("id"));

    const [bannerTopoImg, setBannerTopoImg] = useState('');
    const [bannerBottomImg, setBannerBottomImg] = useState('');

    function scrollToTop() {
        scroll.scrollToBottom();
    }



    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            setAnaliseSucesso(false)
            console.log({api_path});
            //console.log({banner_path});
        }
        return () =>{
            unmounted=true;
        };
    }, [CulturaCombo])

    useEffect(()=>{
        //console.log(faseExportada+'  ######');
    }, [faseExportada])


    const [loading, setLoading] = useState(false);


    //const bodybannerTopo = { tipo: 'sistema-topo', limit: '1', type: 'json'}
    //axios.post(api_path()+'banners/', bodybannerTopo, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})

    const culturaslista = async () => {

        const storageUser0 = localStorage.getItem("SistemaUser");
        let storageSistemaUser0 = JSON.parse(storageUser0);

        const bodyUser = { type: storageSistemaUser0.user_id}
        const cults = await axios.post(api_path()+'sistema/analisesolo/culturas.php', bodyUser, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        const listaCulturas = cults.data;
        //console.log('#########');
        //console.log(listaCulturas);
        //console.log('#########');
        setCulturas([]);
        setCulturas(listaCulturas)
        setLoading(true);
    }


    useEffect(()=>{
        bannerTopo()
        bannerBottom()
        let unmounted = false;
        if(!unmounted){
            //M.AutoInit();
            const storageUser = localStorage.getItem("SistemaUser");
            if(storageUser){
                let storageSistemaUser = JSON.parse(storageUser);
                let solo_id = storageSistemaUser.solo_id;
                let user_id = storageSistemaUser.user_id;
                let user_token = storageSistemaUser.user_token;
                setToken(user_token);
                setAnalise(solo_id);
            }
            if (!loading){
                culturaslista()
            }

            //console.log('$$$$$  analise= '+analise);

             if(laudo_id!=="" && laudo_id!==null){
                setLaudo_id(laudo_id);
                getDadosAnalise();

            }


        }
        return () =>{
            unmounted=true;
            
        };
    }, [analise, laudo_id])




    function handleProp_hectares(e){
        let hec = e.target.value.toString().replace(",", ".");
        //let hec = e.target.value;
        var hec2alc = hec/2.42;
        let hec2alcFinal = hec2alc.toString().replace(".", ",");
        setprop_hectares(hec.toString().replace(".", ","));
        //console.log(hec2alcFinal);
        setprop_alqueires(hec2alcFinal);
        
    }
    function handleProp_alqueires(e){
        let alc = e.target.value.toString().replace(",", ".");
        var alc2hec = alc*2.42;
        let alc2hecFinal = alc2hec.toString().replace(".", ",");
        setprop_alqueires(alc.toString().replace(".", ","));
        //console.log(alc2hecFinal);
        setprop_hectares(alc2hecFinal);
    }



    function bannerTopo(){

        const bodybannerTopo = { tipo: 'sistema-topo', limit: '1', type: 'json'}

        axios.post(api_path()+'banners/', bodybannerTopo, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {

            let dadosAnalise = response.data;
            let bannerTopoArquivo = dadosAnalise['0'].arquivo;
            console.log(bannerTopoArquivo);
            if(bannerTopoArquivo!==""){
                setBannerTopoImg(bannerTopoArquivo);
            }
            
            })
            .catch(function (response) {
                console.log('Ocorreu um erro ao resgatar o banner topo');
                //alert('Ocorreu um erro ao resgatar o banner topo');
            });
            return;
      }        
    

    function bannerBottom(){

        const bodybannerBottom = { tipo: 'sistema-footer', limit: '1', type: 'json'}

        axios.post(api_path()+'banners/', bodybannerBottom, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {

            let dadosAnalise = response.data;
            let bannerBottomArquivo = dadosAnalise['0'].arquivo;
            console.log(bannerBottomArquivo);
            if(bannerBottomArquivo!==""){
                setBannerBottomImg(bannerBottomArquivo);
            }
            
            })
            .catch(function (response) {
                console.log('Ocorreu um erro ao resgatar o banner topo');
                //alert('Ocorreu um erro ao resgatar o banner Bottom');
            });
            return;
      }  

      



    async function getDadosAnalise() {
        /*async function  getDadosAnalise(){*/
        //console.log('getDadosAnalise ATIVADO');
        //console.log(laudo_id);
        //const [analise, setAnalise] = useState();
        const storageUser0 = localStorage.getItem("SistemaUser");
        let storageSistemaUser0 = JSON.parse(storageUser0);

        let dataUser = {
            user_id: storageSistemaUser0.user_id,
            user_email: storageSistemaUser0.user_email,
            user_nome: storageSistemaUser0.user_nome,
            solo_id: laudo_id,
            user_token: storageSistemaUser0.user_token
        };

        localStorage.setItem('SistemaUser', JSON.stringify(dataUser));
        const storageUser1 = localStorage.getItem("SistemaUser");
        let storageSistemaUser1 = JSON.parse(storageUser1);

        setAnalise(storageSistemaUser1.solo_id);

        const bodyGetAnalise = {
            token: token,
            analise: analise,
            acao: 'consultar'
        };

            await axios.post(api_path() + 'sistema/analisesolo/analise_solo.php', bodyGetAnalise, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
            .then(response => {
                var dadosGetAnalise = response.data;
                var dadosGetAnaliseComponentes = dadosGetAnalise.itens[0];
                setprop_nomepropriedade(dadosGetAnalise.prop_nomepropriedade);
                setprop_nome(dadosGetAnalise.prop_nome);
                setprop_fone(dadosGetAnalise.prop_fone);
                setprop_email(dadosGetAnalise.prop_email);
                setprop_lote(dadosGetAnalise.prop_lote);
                setprop_gleba(dadosGetAnalise.prop_gleba);
                setprop_matricula(dadosGetAnalise.prop_matricula);
                
                if(dadosGetAnalise.prop_hectares!==null) setprop_hectares(dadosGetAnalise.prop_hectares);
                if(dadosGetAnalise.prop_alqueire!==null) setprop_alqueires(dadosGetAnalise.prop_alqueire);
                
                if(dadosGetAnalise.prop_cidade!==null) setprop_cidade(dadosGetAnalise.prop_cidade);
                if(dadosGetAnalise.prop_uf!==null) setprop_uf(dadosGetAnalise.prop_uf);
                
                if(dadosGetAnalise.cultura!==null) setCultura(dadosGetAnalise.cultura);
                if(dadosGetAnalise.cultura_id!==null) setCultura_id(dadosGetAnalise.cultura_id);
                if(dadosGetAnalise.cultura_id!==null) setCulturaCombo(dadosGetAnalise.cultura_id);

                if(dadosGetAnalise.fase_gatilho!==null) setFase_gatilho(dadosGetAnalise.fase_gatilho);
                if(dadosGetAnalise.ano_aplicacao!==null) setAno_aplicacao(dadosGetAnalise.ano_aplicacao);

                if(dadosGetAnalise.produtividade!==null) setProdutividade(dadosGetAnalise.produtividade);
                if(dadosGetAnalise.identificacao_amostra!==null) setIdentificacao_amostra(dadosGetAnalise.identificacao_amostra);
                if(dadosGetAnalise.talhao!==null) setTalhao(dadosGetAnalise.talhao);
                if(dadosGetAnalise.profundidade_cm!==null) setProfundidade_cm(dadosGetAnalise.profundidade_cm);
                if(dadosGetAnaliseComponentes.ph_cacl2!==null) setPh_cacl2(dadosGetAnaliseComponentes.ph_cacl2);
                if(dadosGetAnaliseComponentes.ph_H2O!==null) setPh_H2O(dadosGetAnaliseComponentes.ph_H2O);
                if(dadosGetAnaliseComponentes.aluminio!==null) setAluminio(dadosGetAnaliseComponentes.aluminio);
                if(dadosGetAnaliseComponentes.hidrogenio!==null) setHidrogenio(dadosGetAnaliseComponentes.hidrogenio);
                if(dadosGetAnaliseComponentes.prnt_calcario!==null) setPrnt_calcario(dadosGetAnaliseComponentes.prnt_calcario);

                if(dadosGetAnaliseComponentes.fosforo!==null) setFosforo(dadosGetAnaliseComponentes.fosforo);
                if(dadosGetAnaliseComponentes.carbono_organico!==null) setCarbono_organico(dadosGetAnaliseComponentes.carbono_organico);
                if(dadosGetAnaliseComponentes.calcio!==null) setCalcio(dadosGetAnaliseComponentes.calcio);
                if(dadosGetAnaliseComponentes.magnesio!==null) setMagnesio(dadosGetAnaliseComponentes.magnesio);
                if(dadosGetAnaliseComponentes.potassio!==null) setPotassio(dadosGetAnaliseComponentes.potassio);
                if(dadosGetAnaliseComponentes.sodio!==null) setSodio(dadosGetAnaliseComponentes.sodio);
                if(dadosGetAnaliseComponentes.enxofre!==null) setEnxofre(dadosGetAnaliseComponentes.enxofre);

                if(dadosGetAnaliseComponentes.cobre!==null) setCobre(dadosGetAnaliseComponentes.cobre);
                //if(dadosGetAnaliseComponentes.cobre!==null) {setCobre(dadosGetAnaliseComponentes.cobre);}
                if(dadosGetAnaliseComponentes.zinco!==null) setZinco(dadosGetAnaliseComponentes.zinco);
                if(dadosGetAnaliseComponentes.ferro!==null) setFerro(dadosGetAnaliseComponentes.ferro);
                if(dadosGetAnaliseComponentes.manganes!==null) setManganes(dadosGetAnaliseComponentes.manganes);
                if(dadosGetAnaliseComponentes.boro!==null) setBoro(dadosGetAnaliseComponentes.boro);
                
                if(dadosGetAnaliseComponentes.cobre===null || dadosGetAnaliseComponentes.zinco===null || dadosGetAnaliseComponentes.ferro===null || dadosGetAnaliseComponentes.manganes===null || dadosGetAnaliseComponentes.boro===null){
                    setIsDisabled(true);
                    //setIsDisabled(false);
                console(' ');
                }

                if(dadosGetAnaliseComponentes.argila!==null) setArgila(dadosGetAnaliseComponentes.argila);
                if(dadosGetAnaliseComponentes.silte!==null) setSilte(dadosGetAnaliseComponentes.silte);
                if(dadosGetAnaliseComponentes.areia!==null) setAreia(dadosGetAnaliseComponentes.areia);

                //console.log(bodyGetAnalise);
                if (dadosGetAnaliseComponentes.cobre !== "" || dadosGetAnaliseComponentes.zinco !== "" || dadosGetAnaliseComponentes.ferro !== "" || dadosGetAnaliseComponentes.manganes !== "" || dadosGetAnaliseComponentes.boro !== "") {
                    setIsDisabled(false);
                }


        })
        .then(rcvdBusinesses => {
        // some stuff
        })
        .catch(err => {
        // some error handling
        });

        return;

    }

    function mosraDadosLaudo(){
        alert(prop_nome);
    }



    function setDadosProprietario(){
        const bodyDadosProp = {
          acao: 'pr_setADadosProprietario',
          valores:{
            token: token,
            analise: analise,
            prop_nomepropriedade: prop_nomepropriedade,
            prop_nome:  prop_nome,
            prop_fone: prop_fone,
            prop_email: prop_email,
            prop_lote: prop_lote,
            prop_gleba: prop_gleba,
            prop_matricula: prop_matricula,
            prop_hectares: prop_hectares,
            prop_alqueire: prop_alqueires,
            prop_cidade: prop_cidade,
            prop_uf: prop_uf
          }
        }

        axios.post(api_path()+'sistema/analisesolo/analise_solo.php', bodyDadosProp, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {

            let dadosAnalise = response.data;
            if(dadosAnalise>0){
                alert('Dados do proprietário salvos com sucesso!');
                if(prop_nome!=="" && prop_lote!=="" && prop_hectares!=="" && prop_alqueires!==""){
                    setprop_nomeDiplay(prop_nome);
                }else{
                    setprop_nomeDiplay('');
                }
            }else{
                alert('Ocorreu um erro ao salvar os dados do proprietário');
            }
            

            })
            .catch(function (response) {
                //console.log(response);
                alert('Ocorreu um erro ao salvar os dados do proprietário!');
            });
            return;
      }

    const [CheckedMicro, setCheckedMicro] = useState(false);

    let micronutrienteCobre = 2.5;

    //if(micronutrienteCobre!=""){setCheckedMicro(true);}

    const [isDisabled, setIsDisabled] = useState(true);
    //var enabled = !disabled;

    function handleChangeCheckedMicro(e) {
        //console.log(micronutrienteCobre);
        e.target.checked===true ? (setIsDisabled(false)) : (setIsDisabled(true));
      }
      
      function handleSubmitDadosProp(e){
        e.preventDefault();
        setDadosProprietario();
    }
    
    function zeraCultura(){
        setCulturaCombo('');
    }

    function handleCulturaCombo(e){

        zeraCultura();
        setCulturaCombo(e.target.value);
        //onClick={getCulturas}
    }

    useEffect(()=>{
        //console.log(analiseSucesso+'  ######');
        let unmounted = false;
        if(!unmounted){
            
            if(analiseSucesso===true){
                setVisibleSalvar('none');
                setVisibleEditar('inline');
            }
        }
        return () =>{
            unmounted=true;
        };
    }, [analiseSucesso])

    
    const [visibleEditar, setVisibleEditar] = useState('inline');
    const [visibleSalvar, setVisibleSalvar] = useState('none');

    useEffect(()=>{
        //console.log(analiseSucesso+'  ######');
        let unmounted = false;
        if(!unmounted){

            if(CulturaCombo===""){
                setVisibleSalvar('inline');
                setVisibleEditar('none');
            }
        }
        return () =>{
            unmounted=true;
        };
    }, [visibleSalvar])



    //const [isDisabled_btSalvar, setIsDisabled_btSalvar] = useState(true);
    const [btSalvar_text, set_btSalvar_text] = useState('Salvar');


    function EditarClick(){
        //alert('clicado');
        //console.log('dadosAnalise');
    
        setVisibleSalvar('inline');
        setVisibleEditar('none');
        setAnaliseSucesso(false);
        
        const bodyDadosPropEditarClick = { token: token, acao: 'resetar', analise: analise}

          axios.post(api_path()+'sistema/analisesolo/analise_solo.php', bodyDadosPropEditarClick, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then((response) => {

            let dadosAnalise = response.data;
            //console.log(dadosAnalise);
            
            })
            .catch(function (response) {
                  //handle error
                  //console.log(response);
            });
            return;

    }


    function handleSubmitAnalise(e){
        set_btSalvar_text('Editando...');
        //console.log('423');
        e.preventDefault();
        const form = e.currentTarget;
        let dados= serialize(form, {hash: true, empty: true})
        const bodyDadosProp = { token: token, acao: 'pr_setADadosAnalise1', dados}
          axios.post(api_path()+'sistema/analisesolo/analise_solo.php', bodyDadosProp, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then((response) => {
            let dadosAnalise = response.data;
            console.log('431');
            if(dadosAnalise.sucesso===1){
                setAnaliseSucesso(true);
                console.log('analiseSucesso');
                console.log('433');
                set_btSalvar_text('Salvar');
                setVisibleSalvar('none');
                setVisibleEditar('inline');
                
                //console.log(dadosAnalise.sucesso);
            }
            scrollToTop();
  
            })
            .catch(function (response) {
                  //handle error
                  //console.log(response);
            });
            return;
    }


    
    return (

        <div className="App grid-container">
        <Header/>

            <link rel="preconnect" href="https://fonts.googleapis.com"/>
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700&display=swap" rel="stylesheet"></link>


        <div class="grid-container">

            <nav role="navigation">
                <ul class="breadcrumbs">
                    <li><a href="../dashboard">Home</a></li>
                    <li>Análise de Solo {'#'+analise}</li>
                </ul>
            </nav>


            { bannerTopoImg!=="" &&
            <div class="grid-x grid-padding-x">
                <div className="small-12 medium-12 large-12 cell gutter-small">
                    <img src={bannerTopoImg} width='700' height='60' className='img-fluid' id='BannerTopo' />
                </div>
            </div>
            }

            <form onSubmit={handleSubmitAnalise}>

            <input type="hidden" name="analise" value={analise}/>
            <input type="hidden" name="token" value={token}/>

            <div class="card">
                <div class="card-divider">
                    <h4>Dados Gerais</h4>
                </div>
                <div class="card-section">

                    <div class="grid-x grid-padding-x">
                        <div className="small-12 medium-6 large-3 cell gutter-small">
                            <label>Nome do Proprietario
                                <input name="nome" id="nome" value={prop_nome} onChange={(e) => setprop_nome(e.target.value)} type="text" required/>
                            </label>
                        </div>
                        <div className="small-12 medium-6 large-2 cell">
                            <label>Fone
                                <input name="fone" id="fone" type="text" value={prop_fone} onChange={(e) => setprop_fone(e.target.value)} required/>
                            </label>
                        </div>
                        <div className="small-12 medium-6 large-4 cell">
                            <label htmlFor="proprietarioemail">E-mail do Proprietário</label>
                            <input name="proprietarioemail" id="proprietarioemail" type="text" value={prop_email} onChange={(e) => setprop_email(e.target.value)} required/>
                        </div>  
                        <div className="small-12 medium-6 large-3 cell">
                            <label htmlFor="prop_nomepropriedade">Nome da Propriedade
                            <input name="prop_nomepropriedade" id="prop_nomepropriedade" type="text" value={prop_nomepropriedade} onChange={(e) => setprop_nomepropriedade(e.target.value)} required/>
                            </label>
                        </div>
                        <div className="small-12 medium-6 large-2 cell">
                            <label htmlFor="lote">Lote
                            <input name="lote" id="lote" type="text" value={prop_lote} onChange={(e) => setprop_lote(e.target.value)}required/>
                            </label>
                        </div>
                        <div className="small-6 medium-6 large-2 cell">
                            <label htmlFor="gleba">Gleba</label>
                            <input name="gleba" id="gleba" type="text" value={prop_gleba} onChange={(e) => setprop_gleba(e.target.value)} required/>
                        </div>
                        <div className="small-6 medium-6 large-2 cell">
                            <label htmlFor="hectares">Matrícula</label>
                            <input name="matricula" id="matricula" type="text" value={prop_matricula} onChange={(e) => setprop_matricula(e.target.value)} required/>
                        </div>  
                        <div className="small-6 medium-6 large-1 cell">
                            <label htmlFor="hectares" className="form-label">Hectares</label>
                            <CurrencyFormat name="hectares" id="hectares"
                            value={prop_hectares} onBlur={(e)=>handleProp_hectares(e)} 
                            thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                        </div>
                        <div className="small-6 medium-6 large-1 cell">
                            <label htmlFor="alqueire" className="form-label">Alqueire</label>
                            <CurrencyFormat name="alqueire" id="alqueire"
                            value={prop_alqueires} onBlur={(e)=>handleProp_alqueires(e)} 
                            thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                        </div>
                        <div className="small-8 medium-6 large-3 cell">
                            <label htmlFor="cidade" className="form-label">Cidade</label>
                            <input type="text" name="cidade" id="cidade" value={prop_cidade} onChange={(e) => setprop_cidade(e.target.value)} aria-label="cidade" aria-describedby="button-addon2"/>
                        </div>  
                        <div className="small-4 medium-6 large-1 cell">
                            <label>Uf
                                <select name="uf" id="uf" value={prop_uf} onChange={(e) => setprop_uf(e.target.value)}>
                                    <option value="PR" >PR</option>
                                </select>
                            </label>
                        </div>  
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-divider">
                    <h4>Parametros Principais</h4>
                </div>
                <div class="card-section">
                    
                <input type="hidden" name="produtividade"/>

                    <div class="grid-x grid-padding-x">
                        <div className="small-12 medium-6 large-3 cell">
                            <label>Cultura
                            <select name="culturaCombo" key="culturaCombo1" value={CulturaCombo} onChange={(e)=>handleCulturaCombo(e)} >
                                <option key="dsd" value="">Selecione...</option>
                                {culturas.map((opt) => <option key={opt.nome} value={opt.codigo}>{opt.nome}</option>)}
                            </select>
                            </label>    
                        </div>
                        <div className="small-12 medium-6 large-9 cell">
                            { CulturaCombo!=="" &&
                            <CampoAuxiliares CulturaCombo={CulturaCombo} fase_gatilho={fase_gatilho} ano_aplicacao={ano_aplicacao} faseExportada={faseExportada}/>
                            }
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x">
                        <div className="small-12 medium-12 large-12 cell"><hr></hr></div>
                    </div>
                    <div class="grid-x grid-padding-x">
                        <div className="small-6 medium-4 large-2 cell">
                            <label htmlFor="prnt_calcario">Prnt do Calcário
                                <CurrencyFormat name="prnt_calcario" id="prnt_calcario"
                            value={prnt_calcario} onChange={(e) => setPrnt_calcario(e.target.value)} 
                            thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                            </label>
                        </div>
                        <div className="small-6 medium-4 large-2 cell">
                            <label htmlFor="identificacao_amostra">Identificação da Amostra
                                <input name="identificacao_amostra" id="identificacao_amostra" value={identificacao_amostra} onChange={(e) => setIdentificacao_amostra(e.target.value)} type="text" className="required"/>
                            </label>
                        </div>
                        <div className="small-6 medium-4 large-2 cell">
                            <label htmlFor="talhao">Talhão
                                <input name="talhao" id="talhao" value={talhao} onChange={(e) => setTalhao(e.target.value)} type="text" className="required" required/>
                            </label>
                        </div>
                        <div className="small-6 medium-4 large-2 cell">
                            <label htmlFor="profundidade_cm">Profundidade
                                <select name="profundidade_cm" key="field_profundidade_cm" value={profundidade_cm} onChange={(e) => setProfundidade_cm(e.target.value)}  required>
                                <option value=""></option>
                                <option value="00-20">00-20 cm</option>
                                <option value="20-40" >20-40 cm</option>
                                </select>
                            </label>
                        </div>
                        <div className="small-6 medium-4 large-1 cell">
                            <label htmlFor="ph_cacl2">pH CaCl²
                            <CurrencyFormat name="ph_cacl2" id="ph_cacl2"
                                value={ph_cacl2} onChange={(e) => setPh_cacl2(e.target.value)} 
                                thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                placeholder="pH CaCl²" required maxLength={6}/>
                                </label>
                        </div>
                        <div className="small-6 medium-4 large-1 cell">
                            <label htmlFor="ph_H2O">pH H2O                 
                            <CurrencyFormat name="ph_H2O" id="ph_H2O"
                                value={ph_H2O} onChange={(e) => setPh_H2O(e.target.value)} 
                                thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                placeholder="pH H2O" required maxLength={6}/>
                                </label> 
                        </div>
                        <div className="small-6 medium-4 large-1 cell">
                            <label htmlFor="aluminio">Alumínio
                            <CurrencyFormat name="aluminio" id="aluminio"
                                value={aluminio} onChange={(e) => setAluminio(e.target.value)} 
                                thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                placeholder="Al" required maxLength={6}/>
                                </label>
                            <div className="unidade">cmolc dm³</div>
                        </div>
                        <div className="small-6 medium-4 large-1 cell">
                            <label htmlFor="hidrogenio">Hidrogênio
                            <CurrencyFormat name="hidrogenio" id="hidrogenio"
                                value={hidrogenio} onChange={(e) => setHidrogenio(e.target.value)} 
                                thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                placeholder="H" required maxLength={6}/>
                            </label>
                            <div className="unidade">cmolc dm³</div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="card">
                <div class="card-divider">
                    <h4>Macronutrientes</h4>
                </div>
                <div class="card-section">

            	    <div class="grid-x grid-padding-x">
                            <div className="small-6 medium-4 large-2 cell">
                                <label htmlFor="fosforo">Fósforo</label>
                                <CurrencyFormat name="fosforo" id="fosforo"
                                    value={fosforo} onChange={(e) => setFosforo(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="P" required maxLength={6}/>
                                <div className="unidade lighten-4">mg dm³</div>
                            </div>
                            <div className="small-6 medium-4 large-2 cell">
                                <label htmlFor="carbono_organico">Carbono Orgânico</label>
                                <CurrencyFormat name="carbono_organico" id="carbono_organico"
                                    value={carbono_organico} onChange={(e) => setCarbono_organico(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="Carbono Orgânico (g dm³)" required maxLength={6}/>
                                <div className="unidade">g dm³</div>
                            </div>
                            <div className="small-6 medium-4 large-2 cell">
                                <label htmlFor="calcio">Cálcio</label>
                                <CurrencyFormat name="calcio" id="calcio"
                                    value={calcio} onChange={(e) => setCalcio(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="Ca" required maxLength={6}/>
                                <div className="unidade">cmolc dm³</div>
                            </div>
                            <div className="small-6 medium-4 large-2 cell">
                                <label htmlFor="magnesio">Magnésio</label>
                                <CurrencyFormat name="magnesio" id="magnesio"
                                    value={magnesio} onChange={(e) => setMagnesio(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="Mg" required maxLength={6}/>
                                <div className="unidade">cmolc dm³</div>
                            </div>
                            <div className="small-6 medium-4 large-2 cell">
                                <label htmlFor="potassio">Potássio</label>
                                <CurrencyFormat name="potassio" id="potassio"
                                    value={potassio} onChange={(e) => setPotassio(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="K" required maxLength={6}/>
                                <div className="unidade">cmolc dm³</div>
                            </div>
                            <div className="small-6 medium-4 large-1 cell">
                                <label htmlFor="sodio">Sódio</label>
                                <CurrencyFormat name="sodio" id="sodio"
                                    value={sodio} onChange={(e) => setSodio(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="Na" required maxLength={6}/>
                                <div className="unidade">cmolc dm³</div>
                            </div>
                            <div className="small-6 medium-4 large-1 cell">
                                <label htmlFor="enxofre">Enxofre</label>
                                <CurrencyFormat name="enxofre" id="enxofre" 
                                    value={enxofre} onChange={(e) => setEnxofre(e.target.value)} 
                                    thousandSeparator={false} decimalSeparator=',' decimalScale='2'
                                    placeholder="S" required maxLength={6}/>
                                <div className="unidade">mg dm³</div>
                            </div>
                    </div>

                </div>
            </div>


                <div class="grid-x">
                    <div className="small-12 medium-7 large-7 cell">

                        <div class="card">
                            <div class="card-divider">
                                <h4>Micronutrientes
                                    <label className="HabilitarMicronutrientes" htmlFor="HabilitarMicronutrientes"><input className="filled-in" type="checkbox" value="" id="HabilitarMicronutrientes" onChange={ handleChangeCheckedMicro }/>Habiliar</label> 
                                </h4>
                            </div>
                            <div class="card-section">

                                    <div class="grid-x grid-padding-x">
                                        <div className="small-6 medium-2 large-2 cell">
                                            <label htmlFor="cobre">Cobre</label>
                                            <CurrencyFormat disabled={isDisabled} name="cobre" id="cobre" value={cobre} onChange={(e) => setCobre(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                            <div className="unidade">mg dm³</div>
                                        </div>
                                        <div className="small-6 medium-2 large-2 cell">
                                            <label htmlFor="zinco">Zinco</label>
                                            <CurrencyFormat disabled={isDisabled} name="zinco" id="zinco" value={zinco} onChange={(e) => setZinco(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                            <div className="unidade">mg dm³</div>
                                        </div>
                                        <div className="small-6 medium-12 large-2 cell">
                                            <label htmlFor="ferro">Ferro</label>
                                            <CurrencyFormat disabled={isDisabled} name="ferro" id="ferro" value={ferro} onChange={(e) => setFerro(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                            <div className="unidade">mg dm³</div>
                                        </div>
                                        <div className="small-6 medium-2 large-2 cell">
                                            <label htmlFor="manganes">Manganês</label>
                                            <CurrencyFormat disabled={isDisabled} name="manganes" id="manganes" value={manganes} onChange={(e) => setManganes(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                            <div className="unidade">mg dm³</div>
                                        </div>
                                        <div className="small-6 medium-2 large-2 cell">
                                            <label htmlFor="boro">Boro</label>
                                            <CurrencyFormat disabled={isDisabled} name="boro" id="boro" value={boro} onChange={(e) => setBoro(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                            <div className="unidade">mg dm³</div>
                                        </div>
                                    </div>
                                
                                </div>
                            </div>

                    </div>
                    <div className="small-12 medium-5 large-5 cell">

                        <div class="card">
                            <div class="card-divider">
                                <h4>Granulometria/Física</h4>
                            </div>
                            <div class="card-section">

                                <div class="grid-x grid-padding-x">
                                    <div className="small-4 medium-4 large-4 cell">
                                        <label htmlFor="argila" className="form-label">Argila</label>
                                        <CurrencyFormat name="argila" id="argila" value={argila} onChange={(e) => setArgila(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                        <div className="unidade">%</div>
                                    </div>
                                    <div className="small-4 medium-4 large-4 cell">
                                        <label htmlFor="silte" className="form-label">Silte</label>
                                        <CurrencyFormat name="silte" id="silte" value={silte} onChange={(e) => setSilte(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                        <div className="unidade">%</div>
                                    </div>
                                    <div className="small-4 medium-4 large-4 cell">
                                        <label htmlFor="areia" className="form-label">Areia</label>
                                        <CurrencyFormat name="areia" id="areia" value={areia} onChange={(e) => setAreia(e.target.value)} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                                        <div className="unidade">%</div>
                                    </div>
                                </div>

                            </div>
                    </div>


                </div>
            </div>

        <div class="grid-x grid-padding-x">
 
          <div className="small-12 medium-12 large-12 cell">
            <button style={{display: visibleEditar}} onClick={EditarClick} type="button" value="editar" name="editar" id="editar" className="button secondary float-right">Editar</button>
            <button style={{display: visibleSalvar}} type="submit" value="salvar" name="salvar" id="salvar" className="button success float-right">{btSalvar_text}</button>
          </div>

        </div>
        </form>

        { analiseSucesso===true &&
            <Fertilizantes analise={analise} cultura={CulturaCombo} profundidade_cm={profundidade_cm}/>
        }





          </div>


            { bannerBottomImg!=="" &&
            <div class="grid-x grid-padding-x">
                <div className="small-12 medium-12 large-12 cell gutter-small">
                    <img src={bannerBottomImg} width='700' height='90' className='img-fluid' id='BannerTopo' />
                </div>
            </div>
            }



      </div>


    );
  }

  export default AnaliseSolo;
